/* Reducers */
const byId = (state = {}, action) => {
  if (action.type === 'RECIEVE_EDITIONS') {
    const nextState = { ...state };
    action.response.forEach((edition) => {
      nextState[edition.id] = edition;
    });
    return nextState;
  }
  return state;
};

export default byId;

/* Selectors: */
export const getEdition = (state, id) => state[id];



// WEBPACK FOOTER //
// ./js/reducers/editions/byId.js